import { Text } from '@acast-tech/decibel';
import { CardShell } from '../cards/common';
import { FilterCard } from '@/components';
import { VisibleFilterKey } from '@/components/cards/FilterCard/Filters';
import { usePageMetadata } from '@/hooks';
import type { AppType } from '@/types';

const VARIANT_MESSAGES: Record<AppType, { description: string; permission: string }> = {
  revenue: {
    description:
      "It looks like you don't have permission to view the revenue data for this network.",
    permission: 'Ask your Network Administrator for "Revenue Analyst" permissions.',
  },
  insights: {
    description: 'You do not have permission to view audience data for this network.',
    permission:
      'If you need access, you can ask your Network administrator for "Analyst" permissions.',
  },
};

interface NoAccessMessageProps {
  hasNetworks?: boolean;
}

const NoAccessMessage = ({ hasNetworks = false }: NoAccessMessageProps) => {
  const { app } = usePageMetadata();
  const { description, permission } = VARIANT_MESSAGES[app];

  return (
    <div className="mt-6 px-6" data-testid="no-access-message">
      {hasNetworks && <FilterCard visibleFilters={[VisibleFilterKey.Networks]} />}

      <CardShell className="text-center">
        <div className="flex justify-center mb-6">
          <img src="/lock.png" width="63" />
        </div>
        <Text variant="h3">Access denied</Text>
        <Text variant="body1">{description}</Text>
        <Text variant="body1">
          {permission} <br />
          <a
            href="https://learn.acast.com/en/articles/4705730-introduction-to-user-management"
            target="_blank"
            rel="noreferrer"
            className="text-linkBlue underline"
          >
            Learn more about how to update permissions
          </a>
        </Text>
      </CardShell>
    </div>
  );
};

export default NoAccessMessage;
